import * as Yup from 'yup';

export interface ForgotPasswordDto {
  email: string,
}

export const forgotPasswordInit: ForgotPasswordDto = { email: '' };

export const forgotPasswordValidationSchema = Yup.object({
  email: Yup.string()
    .email('Invalid email address')
    .required('Required'),
})